import { MeetingModeEnum } from 'interfaces/MeetingMode';
import { Button, Icon } from 'modules';
import React, { useContext, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { selectConsultantAccess, selectOnlineForm } from 'stores/onlineForm/onlineForm';
import './style.scss';

const MeetingTypeSelector = () => {
  const wsContext = useContext(WebsocketContext);

  const [opened, setOpened] = useState<boolean>(false);

  const form = useSelector(selectOnlineForm);
  const isConsultantAccess = useSelector(selectConsultantAccess);

  const onClose = (): void => {
    setOpened(false);
  };

  const onOpen = (e: any): void => {
    e.preventDefault();
    e.stopPropagation();
    setOpened(true);
  };

  const onSubmitMode = (mode: string) => {
    wsContext?.send({
      action: WebsocketActions.MEETING_MODE_CHANGE,
      value: mode,
    });
    onClose();
  };

  if (!form || !form.form_id || !isConsultantAccess) {
    return null;
  }

  return (
    <div className="meetingTypeSelector">
      <Icon type="cog" onClick={onOpen} />
      <Modal
        show={opened}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        animation={false}
        dialogClassName="modal-80w max-w-700"
      >
        <Modal.Header closeButton>
          <Modal.Title>Typ schôdzky</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Vyberte prosím typ stretnutia</p>
          <Row>
            <Col md={6} sm={12} className="mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Online</h5>
                  <p className="card-subtitle">
                    Klient je online na inom mieste, v priebehu stretnutia musí klient niektoré kroky schvaľovať.
                    <br />
                    Bez účasti klienta nebude možné niektorými krokmi prejsť.
                  </p>
                  <div className="text-right mt-3">
                    <Button variant="primary" onClick={() => onSubmitMode(MeetingModeEnum.ONLINE)}>
                      Pokračovať online
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} sm={12}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Offline</h5>
                  <p className="card-subtitle">Klient je fyzicky prítomný na rokovaní.</p>
                  <div className="text-right mt-3">
                    <Button variant="primary" onClick={() => onSubmitMode(MeetingModeEnum.OFFLINE)}>
                      Pokračovať offline
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MeetingTypeSelector;
